import React, { PropTypes, Component } from 'react'
import Panel from 'react-bootstrap/lib/Panel'
import Forward from 'react-icons/lib/md/arrow-forward'
import { Fieldset, Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'

import FieldGroupRow from 'components/FieldGroupRow'
import InputSelect from 'components/InputSelect'
import InputRadio from 'components/InputRadio'

import CivilStatus from 'constants/civil_status'
import Sex from 'constants/sex'

class StudentData extends Component {

  _forward = () => {
    this.props.setStep(1)
  }

  render() {
    return (
      <Panel header="Student Information">
        <div className="m-b-20 text-right">
          <button type="button" onClick={this._forward} className="btn btn-info">Advising <Forward /></button>
          <hr />
        </div>
        <Fieldset legend="Basic Information">
          <FieldGroupRow
            model=".last_name"
            label="Last Name"
            required
            autoFocus
          />
          <FieldGroupRow
            model=".first_name"
            label="First Name"
            required
          />
          <Row>
            <Field span="3">
              <Input
                model=".middle_name"
                label="Middle Name"
              />
            </Field>
            <Field span="1">
              <Input
                model=".suffix_name"
                label="Ext Name"
              />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input
                model=".dob"
                label="Date of Birth"
                placeholder="Jan 1, 2000"
                required
              />
            </Field>
            <Field>
              <InputRadio
                model=".sex"
                label="Sex"
                options={Sex}
                required
              />
            </Field>
            <Field>
              <InputSelect
                model=".civil_status"
                label="Civil Status"
                options={CivilStatus}
                required
              />
            </Field>
          </Row>
        </Fieldset>
        <Fieldset legend="Personal Information">
          <Row>
            <Field span="3">
              <Input
                model=".address"
                label="Permanent Address"
              />
            </Field>
            <Field span="1">
              <Input
                model=".zip"
                label="Zip Code"
              />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input
                model=".citizenship"
                label="Citizenship"
              />
            </Field>
            <Field>
              <Input
                model=".religion"
                label="Religion"
              />
            </Field>
            <Field>
              <Input
                model=".meta.contact1"
                label="Mobile # (639123456789)"
              />
            </Field>
          </Row>
        </Fieldset>
        <Fieldset legend="Education Background">
          <Row>
            <Field span="3">
              <Input model=".meta.intermediate_name" label="Intermediate" />
            </Field>
            <Field>
              <Input model=".meta.intermediate_sy" label="School-Year" />
            </Field>
          </Row>
          <FieldGroupRow model=".meta.intermediate_address" label="Intermediate School Address" />
          <Row>
            <Field span="3">
              <Input model=".meta.secondary_name" label="Secondary" />
            </Field>
            <Field>
              <Input model=".meta.secondary_sy" label="School-Year" />
            </Field>
          </Row>
          <FieldGroupRow model=".meta.secondary_address" label="Secondary School Address" />
        </Fieldset>
      </Panel>
    )
  }
}

StudentData.propTypes = {
  setStep: PropTypes.func,
}

export default StudentData



// WEBPACK FOOTER //
// ./src/containers/Admission/student-data.js